import 'babel-polyfill'; // support IE11 and below
import 'raf/polyfill'; // support IE9?
import flagsmith from '@flagsmith/flagsmith';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

// noinspection JSFileReferences: suppress warnings and keep .js suffix to avoid the .mjs variant from breaking builds.
import { FlagsmithProvider } from '@flagsmith/flagsmith/react.js';

// import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';
import PlatoClientProvider from './PlatoClientProvider';
import { StoreProvider } from './Store';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { isTest } from './mixins/EnvironmentMixin';

// Register font-awesome SVGs into @fortawesome's library. This mustn't be done inside a component.
library.add(fas);
library.add(far);

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // Once a query is fetched, treat the data valid forever.
            staleTime: Infinity,
            cacheTime: Infinity,

            // For the time being, we'll only fetch enabled queries once.
            refetchInterval: false,
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
        },
    },
});

const flagsmithEnvironmentID = process.env.REACT_APP_FLAGSMITH_ENV_ID;
const flagsmithOptions = {
    environmentID: flagsmithEnvironmentID,
    cacheFlags: !isTest(),
    defaultFlags: {},
};

ReactDOM.render(
    <QueryClientProvider client={ queryClient }>
        <FlagsmithProvider
            flagsmith={ flagsmith }
            options={ flagsmithOptions }
        >
            <PlatoClientProvider>
                <StoreProvider>
                    <App />
                </StoreProvider>
            </PlatoClientProvider>
        </FlagsmithProvider>
    </QueryClientProvider>,
    document.getElementById('root'),
);

// registerServiceWorker();
unregister();
